<template>
  <div
    :class="[
      $style.mainPageBannerItem,
      {
        [$style.mainPageBannerItemAnimationPlay]: isAnimating,
        [$style.mainPageBannerWithoutAnimation]: isWithoutAnimation,
      },
    ]"
  >
    <div :class="$style.mainPageBannerItemContent">
      <div :class="$style.mainPageBannerItemCalendar">
        <BannerCalendar
          v-if="finishDate && startDate"
          class=""
          :end-date="finishDate"
          :start-date="startDate"
        />
      </div>
      <div :class="$style.mainPageBannerItemText">
        <div :class="$style.mainPageBannerItemTextHolder">
          <Markdown :class="$style.mainPageBannerItemTextMain" :text="subtitleFirst" />
          <Markdown :class="$style.mainPageBannerItemTextSecondary" :text="subtitleSecond" />
        </div>
        <slot name="beforeButtom" />
        <template v-if="disableButton">
          <BitButton
            v-if="!buttonAction && buttonText"
            :class="$style.mainPageBannerItemButton"
            is-fill
            :size="{
              width: 'max',
              height: 'md',
            }"
            color="cyan"
            @click="$emit('buttonClick')"
          >
            {{ buttonText }}
          </BitButton>
          <BannerButton
            v-else
            :class="$style.mainPageBannerItemButton"
            :button-action="buttonAction"
          >
            {{ buttonText }}
          </BannerButton>
        </template>
      </div>
    </div>
    <div :class="$style.mainPageBannerItemImage">
      <div :class="$style.mainPageBannerItemImageMain">
        <img
          v-for="(image, i) in imgs"
          :key="i"
          fetchpriority="high"
          :src="image"
          :style="{ display: image === frontImage.url ? 'block' : 'none' }"
          alt="Banner Front image"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { BitButton } from '@bit/ui-kit';
import Markdown from '~/components/markdown.vue';
import BannerButton from '../bannerButton/bannerButton.vue';
import BannerCalendar from '../bannerCalendar/bannerCalendar.vue';
import type { IMainPageBannersData } from '~/types/banners';
import type { IStrapiImage } from '~/types/strapiImage';

const props = defineProps({
  finishDate: {
    type: String,
    default: '',
  },
  startDate: {
    type: String,
    default: '',
  },
  subtitleFirst: {
    type: String,
    required: true,
  },
  subtitleSecond: {
    type: String,
    required: true,
  },
  frontImage: {
    type: Object as PropType<IStrapiImage>,
    required: true,
  },
  buttonText: {
    type: String,
    required: true,
  },
  disableButton: {
    type: Boolean,
    default: true,
  },
  buttonAction: {
    type: Array as PropType<IMainPageBannersData['bannerAction']>,
    default: undefined,
  },
  isAnimating: {
    type: Boolean,
    default: false,
  },
  isWithoutAnimation: {
    type: Boolean,
    default: false,
  },
});

defineEmits<{
  (e: 'buttonClick'): void;
}>();

const imgs = ref<string[]>([]);
watch(
  () => props.frontImage.url,
  (val) => {
    if (!imgs.value.includes(val)) {
      imgs.value.push(val);
    }
  },
  { immediate: true }
);
</script>
<style lang="scss" module src="./mainBanner.scss"></style>
